module.exports = __webpack_public_path__ + "static/media/openbrix-favicon.1588b58f.jpg";